import MainContext from "./Context";

const MainStates = (props) => {
  const isNotWebview = new URLSearchParams(window.location.search).get("v") !== "webview";
  return (
    <MainContext.Provider value={{ isNotWebview }}>
      {props.children}
    </MainContext.Provider>
  );
};
export default MainStates;
